import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  loadModal() {
    const modalBody = document.getElementById("consolidation-modal-body")
    if (!modalBody) return

    // Mostrar spinner
    modalBody.innerHTML = `
      <div class="text-center py-4">
        <i class="fas fa-spinner fa-spin fa-2x text-muted"></i>
        <p class="text-muted mt-2">Cargando órdenes...</p>
      </div>
    `

    fetch(this.urlValue, {
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    .then(response => response.text())
    .then(html => {
      modalBody.innerHTML = html
    })
    .catch(error => {
      modalBody.innerHTML = `
        <div class="alert alert-danger mb-0">
          <i class="fas fa-exclamation-triangle mr-1"></i>
          Error al cargar las órdenes. Intente nuevamente.
        </div>
      `
    })
  }
}
